import React, {Component} from 'react';
import {withStyles} from 'material-ui/styles';
import {FormControl, Typography} from 'material-ui';
import Select from 'react-select';
import {capitalizeFirstLetter} from '../../../../components/helpers/helpers';
import red from 'material-ui/colors/red';
import classNames from 'classnames';

class AddPageTagsSelect extends Component {
    render() {
        const {
            classes,
            allPageTags,
            onUpdatePageTags,
            onMultipleTagsUpdate,
            pageTagsForDisplay,
            selectHasError,
            hasError,
            pageId,
        } = this.props;

        let Selects = Object.values(allPageTags)
            .slice(1)
            .map((tagsValues, index) => {
                let tagsKey = Object.entries(allPageTags)[index + 1][0];
                let tagsName = capitalizeFirstLetter(
                    tagsKey.replace(/_/g, ' ')
                );
                tagsName += tagsKey !== 'all' ? ' *' : '';
                let multipleKey = Object.values(allPageTags)[0];
                let multipleSelect = multipleKey[tagsKey];
                let currentTag = pageTagsForDisplay[tagsKey]
                    ? pageTagsForDisplay[tagsKey]
                    : [];

                let tagsHaveErrors = classNames(
                    selectHasError(
                        currentTag,
                        `select-multiple-chip-${tagsKey}`
                    ) && classes.hasErrors
                );

                return (
                    <span key={index} className={classes.formControl}>
                        {currentTag && (
                            <span>
                                <FormControl className={classes.formControl}>
                                    <Typography
                                        variant="body2"
                                        className={
                                            tagsKey !== 'all'
                                                ? tagsHaveErrors
                                                : ''
                                        }
                                    >
                                        {tagsName}
                                    </Typography>
                                    <Select
                                        multi={multipleSelect}
                                        closeOnSelect={
                                            multipleSelect ? false : true
                                        }
                                        placeholder={
                                            'Type to search and select ' +
                                            tagsName +
                                            ' here...'
                                        }
                                        name={`select-multiple-chip-${tagsKey}`}
                                        id={`select-multiple-chip-${tagsKey}`}
                                        value={
                                            multipleSelect
                                                ? currentTag
                                                : currentTag[0]
                                        }
                                        valueKey={'id'}
                                        labelKey={'term'}
                                        onChange={(currentTag) => {
                                            if (multipleSelect) {
                                                if (currentTag.length < 1) {
                                                    hasError(tagsKey, true);
                                                } else {
                                                    hasError(tagsKey, false);
                                                }
                                                onMultipleTagsUpdate(
                                                    currentTag,
                                                    tagsKey,
                                                    pageId
                                                );
                                            }
                                            if (!multipleSelect) {
                                                if (currentTag === null) {
                                                    hasError(tagsKey, true);
                                                } else {
                                                    hasError(tagsKey, false);
                                                }

                                                onUpdatePageTags(
                                                    currentTag,
                                                    tagsKey,
                                                    pageId
                                                );
                                            }
                                        }}
                                        options={tagsValues}
                                        fullWidth
                                    />
                                </FormControl>
                                <Typography variant="caption">
                                    Select {tagsName} from the drop-down
                                </Typography>
                            </span>
                        )}
                    </span>
                );
            });

        return <div className={classes.root}>{Selects}</div>;
    }
}

const styles = () => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        width: '100%',
        marginBottom: 50,
    },
    formControl: {
        marginTop: 3,
        minWidth: 100,
        width: '100%',
    },
    hasErrors: {
        color: red[500],
    },
});

export default withStyles(styles)(AddPageTagsSelect);



// WEBPACK FOOTER //
// ./src/containers/builder/form/popups/page_tags_edit.js